<template>
  <div id="app" v-if="!waitInit">
    <keep-alive :include="['NewsList', 'Announcement']">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import { listenBodyHeight, sendMsg, unListenBodyHeight, watchMsg } from '@/plugins/msg'
import { translatePage } from '@/utils/utility-lang'
import { getDebugSettings } from './utils/api'

export default {
  data() {
    return {
      waitInit: true
    }
  },
  watch: {
    '$route.query.brokerStockHoldings': {
      handler(newVal) {
        if (newVal === null || newVal === undefined) return

        localStorage.setItem('brokerStockHoldings', newVal)
      },
      immediate: true
    },
    '$route.query.lang': {
      // 语言切换，当lang有值时生效，未匹配默认简体中文
      handler(newVal) {
        if (!newVal) return

        localStorage.setItem('lang', newVal)
        translatePage(newVal)
      },
      immediate: true
    },
    '$route.query.debug': {
      // 是否开启 debug 模式，debug = true 时开启
      handler(newVal) {
        if (newVal) {
          localStorage.debug = getDebugSettings()
        }
      },
      immediate: true
    },
    '$route.query.token': {
      // 语言切换，当lang有值时生效，未匹配默认简体中文
      handler(newVal) {
        if (!newVal) return
        localStorage.setItem('token', newVal)
      },
      immediate: true
    },
    '$route.query.init': {
      handler(newVal) {
        if (newVal !== 'true') {
          this.waitInit = false
          return
        }
        this.waitInit = true
        sendMsg({ event: 'init' })
      },
      immediate: true
    }
  },
  created() {},
  mounted() {
    listenBodyHeight()

    watchMsg(this.watchCallback)
  },
  methods: {
    watchCallback(res) {
      if (res.event === 'initRes') {
        if (res?.data?.rmToken) {
          window.rmToken = `bearer ${res.data.rmToken}`
        }

        this.waitInit = false
      }
    }
  },
  beforeDestroy() {
    unListenBodyHeight()
  }
}
</script>
<style lang="scss" scoped>
#app {
  display: flex;
  flex-direction: column;
}
</style>
